import { Modal } from '@shared/components';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { useConciergeContext } from '@shared/plugin/contexts/ConciergeContext';
import { useCallback, useState } from 'react';
import { ChatsPage } from '../chats-page/ChatsPage';
import { AskVeeButton } from './AskVeeButton';
import { ChatWithVeeButtonProps } from './types';

export function PluginChatWithVeeButton({
  contextEntities,
}: ChatWithVeeButtonProps) {
  const { hasAccessToConcierge } = useConciergeContext();
  const { track } = useAnalytics();
  const [isOpen, setIsOpen] = useState(false);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const getViewContext = useCallback(
    () => ({ entityIds: contextEntities }),
    [contextEntities]
  );

  if (!hasAccessToConcierge) return null;

  const onPress = async () => {
    await track('Clicked Chat with Vee', {
      data: contextEntities,
    });
    setConversationId(null);
    setIsOpen(true);
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={setIsOpen}>
      <AskVeeButton onPress={onPress} />
      <Modal.Content
        size="responsive-takeover"
        className="flex h-full flex-col"
      >
        <Modal.Header title="Chat with Vee" hasCloseButton className="px-4" />
        <div className="flex min-h-[300px] flex-1 flex-col overflow-hidden">
          <ChatsPage
            conversationId={conversationId}
            getViewContext={getViewContext}
            hasUrlFilters={false}
            isCompact
            onConversationSelect={setConversationId}
          />
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
